var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertPopup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#ED4040",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0628 16.5C29.7448 15.972 29.2957 15.5352 28.7591 15.232C28.2225 14.9288 27.6166 14.7694 27.0003 14.7694C26.3839 14.7694 25.778 14.9288 25.2414 15.232C24.7048 15.5352 24.2557 15.972 23.9378 16.5L14.0878 32.5875C13.7575 33.1313 13.5777 33.7531 13.5669 34.3892C13.5561 35.0253 13.7147 35.6528 14.0264 36.2075C14.338 36.7621 14.7916 37.2239 15.3405 37.5455C15.8895 37.8671 16.5141 38.0369 17.1503 38.0375H36.8503C37.4865 38.0369 38.1111 37.8671 38.66 37.5455C39.2089 37.2239 39.6625 36.7621 39.9742 36.2075C40.2858 35.6528 40.4444 35.0253 40.4336 34.3892C40.4228 33.7531 40.2431 33.1313 39.9128 32.5875L30.0628 16.5Z",
    fill: "#ED4040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 29.9375C26.7524 29.9343 26.5158 29.8345 26.3407 29.6593C26.1655 29.4842 26.0657 29.2476 26.0625 29V23.375C26.0625 23.1264 26.1613 22.8879 26.3371 22.7121C26.5129 22.5363 26.7514 22.4375 27 22.4375C27.2486 22.4375 27.4871 22.5363 27.6629 22.7121C27.8387 22.8879 27.9375 23.1264 27.9375 23.375V29C27.9343 29.2476 27.8345 29.4842 27.6593 29.6593C27.4842 29.8345 27.2476 29.9343 27 29.9375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 33.375C27.6904 33.375 28.25 32.8154 28.25 32.125C28.25 31.4346 27.6904 30.875 27 30.875C26.3096 30.875 25.75 31.4346 25.75 32.125C25.75 32.8154 26.3096 33.375 27 33.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertPopup);
export default __webpack_public_path__ + "static/media/alertPopup.17ddab9f09e469df7d57b76804692408.svg";
export { ForwardRef as ReactComponent };